<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'Hadoops',
    data(){
        return{

        }
    }
}
</script> 
<style scoped lang="scss">
    
</style>